import axios from "axios";

// Configure axios base URL from environment. On Render static site, set
// REACT_APP_API_BASE_URL to the backend service URL (for example
// https://<backend>.onrender.com/api). If absent, axios will use relative URLs.
const apiBase = process.env.REACT_APP_API_BASE_URL || "";

if (apiBase) {
  axios.defaults.baseURL = apiBase;
}

// You can enable credentials (cookies) when your backend expects them:
// axios.defaults.withCredentials = true;

// Default timeout for API calls
axios.defaults.timeout = 30000; // 30s

export default axios;
